<div class="page-container">
  <div class="page-header">
    <div>
      <h1 class="page-title">Smartes Wiederholen</h1>
    </div>
  </div>

  <div class="widgets-row">
    <app-repetition-count-widget (totalCardsCountChange)="totalSmartRepetitionCards = $event"></app-repetition-count-widget>
    <app-mastered-count-widget></app-mastered-count-widget>
    <app-weekly-goal-widget></app-weekly-goal-widget>
  </div>

  <app-smart-repetition-list *ngIf="courses && courses.length > 0" [courses]="courses"></app-smart-repetition-list>

  <div *ngIf="totalSmartRepetitionCards === 0" class="initial-tip">
    <i-tabler name="alert-circle"></i-tabler>
    <h2>Smartes Wiederholen ist noch nicht aktiviert</h2>
    <p>Aktiviere Smartes Wiederholen in deinen Lernsets. Deine Karten werden automatisch genau dann angezeigt, wenn der perfekte Zeitpunkt zum Wiederholen ist.</p>
  </div>
  
  <div *ngIf="totalSmartRepetitionCards && totalSmartRepetitionCards > 0 && courses && courses.length === 0" class="initial-tip">
    <i-tabler name="circle-dashed-check"></i-tabler>
    <h2>Super, du hast alles geschafft! 🎉</h2>
    <p>Aktuell gibt es keine Karteikarten zur Wiederholung – gönn dir eine Pause, bald geht’s weiter.</p>
  </div>
</div>